import { EyeCheckIcon } from './EyeCheckIcon';

/**
 * author: Austin Andrews
 * id 7534EBC5-1A5B-4837-8C13-88CFA5FB4D49
 * name eye-check
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-check.svg
 * tags
 */
export const EyeTickIcon = EyeCheckIcon;
export default EyeTickIcon